import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@gsa/afp-component-library';
import { useLazyQuery } from '@apollo/client';
import OverlaySpinner from '../../../components/overlay-spinner';
import { FT_XLSX } from '../../bids/components/bid-reports/bid-report-types';
import {
  GET_JS_REPORT,
  getDownloadAlert,
} from '../../bids/bid-reports/bid-report-helpers';

const PreBidReportDownloadLink = ({ filters, setAlert }) => {
  const [contractYear, setContractYear] = React.useState(null);
  const [getJSReportData, { loading: loadingJSReport }] = useLazyQuery(
    GET_JS_REPORT,
    {
      fetchPolicy: 'network-only',
      onCompleted: ({ getJSReport: res }) => {
        setAlert(
          getDownloadAlert(
            `${res.reportName}`,
            res.content.data,
            res.contentType,
            `${res.reportName} ${contractYear}.${res.fileExtension}`,
          ),
        );
      },
    },
  );

  const onDownload = () => {
    setAlert(null);
    const queryParams = {};

    for (const filter of filters.value) {
      switch (filter.key) {
        case '$preBidSelection.contract_year$':
          queryParams.contractYears = [filter.value];
          break;
        case '$preBidSelection.vendor_id$':
          queryParams.vendorIds = [filter.value];
          break;
        case '$preBidSelection.intent_to_bid$':
          if (filter.value.length === 1)
            queryParams.intentToBid = filter.value[0];
          break;
        case '$preBidSelection.standard_item_id$':
          if (filter.value.length > 0)
            queryParams.standardItemIds = filter.value;
          break;
        case '$preBidSelection.vehicle_group_code$':
          queryParams.vehicleGroupCode = filter.value;
          break;
        case '$preBidSelection.standardItem.fed_standard_code$':
          if (filter.value.length > 0)
            queryParams.fedStandardCode = filter.value[0];
          break;
        default:
          break;
      }
    }
    if (queryParams.contractYears?.length !== 1) {
      setAlert({
        type: 'error',
        message:
          'Contract year selection is required to download pre-bid report',
      });
      return;
    }
    setContractYear(queryParams.contractYears[0]);

    getJSReportData({
      variables: {
        input: {
          reportTypeId: 517,
          outputType: FT_XLSX,
          queryParams,
        },
      },
    });
  };

  if (loadingJSReport) return <OverlaySpinner />;

  return (
    <div className="float-right">
      <Button
        data-testid="pre-bid-report-download-csv-button"
        onClick={onDownload}
        type="custom"
        label="Download vendor pre-bid selection report"
        leftIcon={{ name: 'file_download' }}
      />
    </div>
  );
};

PreBidReportDownloadLink.propTypes = {
  filters: PropTypes.shape(Object).isRequired,
  setAlert: PropTypes.func.isRequired,
};

export default PreBidReportDownloadLink;
